import { useLayoutNotificationsState } from '@/components/Layout';
import { PushNotificationConfig, usePushNotifications } from '@/hooks/usePushNotifications';
import { useEffect } from 'react';
import { useNotify } from 'react-admin';
import { useQueryClient } from 'react-query';

type FcmForegroundListenerProps = {
  config: PushNotificationConfig;
};

function FcmForegroundListener({ config }: FcmForegroundListenerProps) {
  const notify = useNotify();
  const queryClient = useQueryClient();
  const { listen } = usePushNotifications(config);
  const { resource } = useLayoutNotificationsState();
  useEffect(() => {
    const unsubscribe = listen(({ title, message }) => {
      notify(message || title, { type: 'info' });
      queryClient.invalidateQueries([resource, 'getList']);
    });
    return unsubscribe;
  }, [notify, queryClient, listen, resource]);
  return null;
}

export { FcmForegroundListener };
export type { FcmForegroundListenerProps };
